import { Languages } from "config/translations/I18n";

export interface UserType {
  readonly id: number;
  readonly active: boolean;
  readonly username?: string;
  readonly corilusPersonId?: string;
  readonly firstName?: string;
  readonly lastName?: string;
  readonly nihii?: string;
  readonly inss?: string;
  readonly displayName?: string;
  readonly language: Languages;
  readonly trigram: string;
}

export class User implements UserType {
  id: number;
  active: boolean;
  username?: string;
  corilusPersonId?: string;
  firstName?: string;
  lastName?: string;
  nihii?: string;
  inss?: string;
  displayName?: string;
  language: Languages;
  trigram: string;

  constructor(data?: UserType) {
    this.id = 0;
    this.active = true;
    this.language = "nl";
    this.nihii = "";
    this.trigram = "";
    data && Object.assign(this, data);
  }
}
